import React from 'react';

import { magellanV0, magellanV1 } from 'api/magellan';
import { MANAGER } from 'authorization/role';
import withSignageLayout from 'hoc/withSignageLayout';
import { useSignage } from 'hooks/useSignage';
import Loading from 'components/common/Loading';
import SignageHeader from 'components/common/SignageHeader';
import ToolForm from './ToolForm';

const UpdateWarehouse = ({ filterDataForServer, role }) => {
    const {editionMode, setEditionMode, item, updateData, loading, isReadonly} = useSignage({ readApi: magellanV1, createApi: magellanV1, updateApi: magellanV1 }, 'devices', false);


    const onSubmit = (formValues) => {
        updateData(filterDataForServer({...formValues}), formValues);
    };

    return (
        <>
            {loading 
                ? <Loading/>
                : <>
                    <SignageHeader editionMode={editionMode} setEditionMode={setEditionMode} editionEnabled={role === MANAGER && !isReadonly} title={item && item.name}/>
                    <ToolForm editionMode={editionMode} onSubmit={onSubmit} initialValues={item} />
                </>
            }
        </>
    );
}

export default withSignageLayout()(UpdateWarehouse);